import React from "react";
import ReactDom from "react-dom";

import {observable, action, computed} from 'mobx';
import {observer} from 'mobx-react';

import {Decorator as editable} from 'simbox-editable';

import autoclass from 'autoclass-decorator';

import BaseComponent from 'base-component';

import {StaticViewStore, StaticTextViewStore, StaticImageViewStore} from './viewstore';
import {StaticContentModel} from './contentmodel';


//@editable // this makes the view editable via authoring tool via data-editable
@observer // mobx manages this view
//@autoclass // this automatically gives consistent `className`s to components using module and component names
export class StaticComponent extends BaseComponent {

    static get ViewStore() {
        return StaticViewStore;
    }
  
    render() {
        return <div>Not Implemented</div>
    }
}


//@editable // this makes the view editable via authoring tool via data-editable
@observer // mobx manages this view
//@autoclass // this automatically gives consistent `className`s to components using module and component names
export class StaticTextComponent extends BaseComponent {

    static get ViewStore() {
        return StaticTextViewStore;
    }
  
    render() {
        const {
            currentView, // the parent view container, may have options etc attached depending on context
            contentModel, // the hydrated contentModel
        } = this.props;

        const {
            css,
            content
        } = contentModel; // this contentModel's properties

        return <div className={"static-content " + css} dangerouslySetInnerHTML={{__html:content}}></div>
    }
}

//@editable // this makes the view editable via authoring tool via data-editable
@observer // mobx manages this view
//@autoclass // this automatically gives consistent `className`s to components using module and component names
export class StaticImageComponent extends BaseComponent {

    static get ViewStore() {
        return StaticImageViewStore;
    }
  
    render() {
        const {
            currentView, // the parent view container, may have options etc attached depending on context
            contentModel, // the hydrated contentModel
        } = this.props;

        const {
            css,
            source,
            alternate,
            width,
            height
        } = contentModel; // this contentModel's properties

        return <img className={"static-image " + css} src={source} alt={alternate} width={width} height={height}/>
    }
}

export default StaticTextComponent; //need to export top level component as "default"



// WEBPACK FOOTER //
// ./app_modules/form-control-activity/static/component.js